/**
 * Details shares its horizontal space with drawers. A viewport media query cannot see that its own
 * pane narrowed, so the grid must choose its column count from the container's inline size.
 */
export function proposalDetailsGridTemplateColumns(minimumColumnWidth: string): string {
  return `repeat(auto-fit, minmax(min(100%, ${minimumColumnWidth}), max-content))`;
}

export function proposalDetailsControlMinimumWidth(minimumColumnWidth: string): string {
  return `min(100%, ${minimumColumnWidth})`;
}

/**
 * The gutter between the general fields and the dates.
 *
 * It was a flat 8rem, which is the right proportion for a pane with 1008px to give and a canyon in one
 * with 608px — the gutter does not care that the columns beside it had to shrink. `cqi` is one percent
 * of the pane's inline size (see `work-pane-layout`), so this reads the same room the columns do:
 * 8rem at the widths the design was drawn for, and proportionally less as the pane narrows, never
 * below a gutter that still separates two columns.
 */
export const proposalDetailsColumnGap = "clamp(1.5rem, 12cqi, 8rem)";
